import { styled } from '@mui/material/styles';

const StyledBox = styled('div')(({ theme }) => ({
    
  height: "auto",
  width: '98%',
  '& .MuiDataGrid-cell--editing': {
    backgroundColor: 'rgba(115, 158, 255, 0.19)',
    color: '#1a3e72',
    '& .MuiInputBase-root': {
      height: '100%',
    },
  },
  '& .MuiDataGrid-row--editable': { 
    outline: '0px',
  },
  '& .MuiDataGrid-cell:focus-within':{
    outline: '0px !important',
  },
  '& .MuiDataGrid-row.Mui-selected': { 
    backgroundColor: 'rgba(115, 158, 255, 0.19) !important',
    '&:hover': {
        backgroundColor: 'rgba(115, 158, 255, 0.19) !important',
      },
  },
  
  '& .MuiDataGrid-cell:focus': { 
    outline: '0px !important',
  },
  '& .Mui-error': {
    backgroundColor: `rgba(126, 10, 15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
    color: theme.palette.error.main,
  },
}));

export default StyledBox;